import { compact } from 'lodash';
import IconSVG from '../../styles/svg-icons';
import { Bank } from '../../types/banks/Bank';
import { OnHoverTooltip } from '../common';
import { BanksAlertsButton } from './BanksAlertsButton';
import { useDispatch } from 'react-redux';
import { banksActions } from '../../actions/banks.actions';

interface Props {
    bank: Bank;
    isAlertOn?: boolean;
    showAlertSection?: boolean;
    showActivities?: boolean;
}

export const BanksLabels = ({ bank, showAlertSection, isAlertOn = false, showActivities = true }: Props) => {
    const dispatch = useDispatch();
    const { hasActiveTransactions, sendsPxTalk, existsOnDealerInventory, activeTransactionsCount } = bank;

    const activitiesCount = compact([hasActiveTransactions, sendsPxTalk, existsOnDealerInventory]).length;

    const hideActivitiesText = hasActiveTransactions ? `(${activeTransactionsCount})` : '';

    const getTooltipOverlay = () => {
        const activities = compact([
            hasActiveTransactions ? 'Primary' : undefined,
            sendsPxTalk ? 'Secondary' : undefined,
            existsOnDealerInventory ? 'Inventory' : undefined
        ]);

        return activities.reduce((acc, activity) => {
            const label = activity === 'Primary' ? `${activity} (${activeTransactionsCount})` : activity;

            return acc ? `${acc}, ${label}` : `Active${activities.length >= 2 ? ':' : ''} ${label}`;
        }, '');
    };

    return (
        <>
            <div className="reg-flags">
                {!!activitiesCount && (
                    <OnHoverTooltip overlay={getTooltipOverlay()}>
                        <IconSVG name="active-manager" width={16} height={16} />
                        <span>{showActivities ? getTooltipOverlay() : hideActivitiesText}</span>
                    </OnHoverTooltip>
                )}
            </div>
            {showAlertSection && (
                <div className="sidebar-controls-item flex-item-right">
                    <OnHoverTooltip overlay="Bank's Profile Alerts">
                        <BanksAlertsButton
                            isAlertOn={isAlertOn}
                            onClick={() => dispatch(banksActions.setBankForAlertPopup(bank.referenceName))}
                        />
                    </OnHoverTooltip>
                </div>
            )}
        </>
    );
};
